import announcer from './aria-announcer';

document.addEventListener('DOMContentLoaded', () => {
    if (window.innerWidth > 768) return;

    const $group = document.querySelector('.search-results-group');
    const $links = $group ? Array.from($group.querySelectorAll('a')) : [];
    const $button = document.querySelector('.btn-search-results-bar');

    if (!$group || !$button || $links.length <= 1) return;

    const extraLinks = $links.slice(1);

    extraLinks.forEach((link) => {
        const linkElement = link;
        linkElement.style.display = 'none';
        linkElement.setAttribute('aria-hidden', 'true');
    });

    $button.addEventListener('click', () => {
        const isHidden = extraLinks[0].style.display === 'none';

        extraLinks.forEach((link) => {
            const linkElement = link;
            linkElement.style.display = isHidden ? 'inline-block' : 'none';
            linkElement.setAttribute('aria-hidden', isHidden ? 'false' : 'true');
        });

        $button.setAttribute('aria-expanded', isHidden ? 'true' : 'false');
        announcer.announce(isHidden ? `${extraLinks.length} filtres supplémentaires affichés` : 'Filtres supplémentaires cachés');
    });
});
